import gravatarUrl from "gravatar-url";

export default function Message({ justify, message, color, sender }) {
  return (
    <li className={`flex justify-${justify} my-2 gap-5`}>
      {justify === "start" && (
        <img
          className="object-cover w-10 h-10 rounded-full"
          src={gravatarUrl(sender.email, {
            size: 80,
          })}
          alt={sender.name}
        />
      )}
      <div
        className={`relative max-w-xl px-4 py-2 text-white rounded-full shadow ${color}`}
      >
        <span className="block">{message}</span>
      </div>
      {justify === "end" && (
        <img
          className="object-cover w-10 h-10 rounded-full"
          src={gravatarUrl(sender.email, {
            size: 80,
          })}
          alt={sender.name}
        />
      )}
    </li>
  );
}
